import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Label, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hasAnyPermission } from 'app/shared/auth/permissions';
import { IRootState } from 'app/shared/reducers';
import { getEntities, getMasterEntities } from './mmama-entity.reducer';
import { IRegion } from 'app/shared/model/region.model';
import { getAllByType as getCountries } from 'app/entities/region/region.reducer';
import 'react-treelist/build/css/index.css';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { IMmamaEntityMaster } from 'app/shared/model/mmama-entity-master.model';
import VillageAvTypeahead from 'app/shared/layout/menus/village-av-typeahead';
import { MmamaEntityType } from 'app/shared/model/enumerations/mmama-entity-type.model';

export interface IMmamaEntityProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const MmamaEntity = (props: IMmamaEntityProps) => {
  const { mmamaEntityList, masterEntities, countries, match, loading, userCountryId, hasUpdateAccess } = props;
  const [activeCountry, setActiveCountry] = useState<IRegion>({});
  const [activeMasterEntity, setActiveMasterEntity] = useState<IMmamaEntityMaster>({});
  const [clearValue, setClearValue] = useState(false);
  const paramMasterEntityId = new URLSearchParams(props.location.search).get('masterEntityId') ?? null;
  const paramCountryId = new URLSearchParams(props.location.search).get('countryId') ?? null;

  useEffect(() => {
    props.getCountries();
    props.getMasterEntities();
  }, []);

  useEffect(() => {
    if (userCountryId && countries.length > 0 && masterEntities.length > 0) {
      let ac: IRegion;
      if (paramCountryId) {
        ac = countries.find(country => country.id === paramCountryId);
      }
      if (!ac) {
        ac = countries.find(country => country.id === userCountryId);
      }
      let ame: IMmamaEntityMaster;
      if (paramMasterEntityId) {
        ame = masterEntities.find(masterEntity => masterEntity.id === paramMasterEntityId);
      } else {
        ame = masterEntities[0];
      }
      setActiveCountry(ac);
      setActiveMasterEntity(ame);
      props.history.push(`${match.url}?masterEntityId=${ame.id}&countryId=${ac.id}`);
      props.getEntities(ac.id, ame.id);
    }
  }, [countries, userCountryId, masterEntities]);

  const onCountryChange = (event) => {
    if (!event.target.value) {
      return;
    }
    const countryId = event.target.value;
    const newActiveCountry = countries.find(country => country.id === countryId);
    setActiveCountry(newActiveCountry);
    props.history.push(`${match.url}?masterEntityId=${activeMasterEntity.id}&countryId=${countryId}`);
    props.getEntities(countryId, activeMasterEntity.id);
  };

  const onMasterEntityChange = (event) => {
    if (!event.target.value) {
      return;
    }
    setClearValue(!clearValue);
    const masterEntityId = event.target.value;
    const newMasterEntity = masterEntities.find(masterEntity => masterEntity.id === masterEntityId);
    setActiveMasterEntity(newMasterEntity);
    props.history.push(`${match.url}?masterEntityId=${newMasterEntity.id}&countryId=${activeCountry.id}`);
    props.getEntities(activeCountry.id, masterEntityId);
  };

  const regCountriesList = countries.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === userCountryId;
  });

  const masterEntitiesList = masterEntities ?
    masterEntities.map((masterEntity) => {
      return {
        short: masterEntity.enumName,
        full: `${masterEntity.entityName} (${masterEntity.enumName})`,
        id: masterEntity.id
      };
    }) : [];

  return (
    <div>
      <h2 id="mmamaEntity-heading">
        Feedback Entity
        {(activeCountry && typeof activeCountry.id !== 'undefined') && (
          <Link to={`${match.url}/create?masterEntityId=${activeMasterEntity.id}&countryId=${activeCountry.id}`}
                className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
            <FontAwesomeIcon icon="plus" />
            &nbsp; Add New Feedback Entry
          </Link>
        )
        }
      </h2>

      <br />
      <AvForm>
        {(regCountriesList && regCountriesList.length > 0) && (
          <AvGroup>
            <Label for="country-filter">Country</Label>
            <AvInput id="country-filter" type="select" className="form-control"
                     name="country-filter" value={activeCountry?.id} onChange={onCountryChange}>
              {regCountriesList
                ? regCountriesList.map(country => (
                  <option value={country.id} key={country.id}>
                    {country.name}
                  </option>
                ))
                : null}
            </AvInput>
          </AvGroup>
        )}
        <br />
        {(masterEntities.length > 0) && (
          <>
            <AvGroup>
              <Label for="mmama-entities-master">Select Feedback Entity</Label>
              <AvInput id="mmama-entities-master" type="select" className="form-control"
                       name="mmama-entities-master" value={activeMasterEntity?.id}
                       onChange={onMasterEntityChange}>
                {[...masterEntities] // sort by name
                  .sort((a, b) => {
                    const aName = a.entityName;
                    const bName = b.entityName;
                    return aName.localeCompare(bName);
                  })
                  .map(masterEntity => {
                    const displayName = masterEntity.entityName;
                    return (
                      <option value={masterEntity.id} key={masterEntity.id}>
                        {displayName} ({masterEntity.enumName})
                      </option>
                    );
                  })}
              </AvInput>
            </AvGroup>
            {hasUpdateAccess && activeMasterEntity?.id && activeMasterEntity.type === MmamaEntityType.DROPDOWN && (
              <Button tag={Link} color="primary" size="sm" id="edit-master-entity"
                      to={`${match.url}/master/${activeMasterEntity.id}/edit?masterEntityId=${activeMasterEntity.id}&countryId=${activeCountry?.id}`}>
                <FontAwesomeIcon icon="pencil-alt" /> Edit Dropdown Entity
              </Button>
            )}
            <br />
            <br />
            <div>or</div>
            <br />
            <AvGroup>
              <Label for="mmama-entities-master-search">Search Feedback Entity</Label>
              <VillageAvTypeahead
                labelKey="short"
                valueKey="id"
                data={masterEntitiesList}
                placeholder={activeMasterEntity.id ? `${activeMasterEntity.entityName} (${activeMasterEntity.enumName})` : 'Feedback Entity'}
                clearValue={clearValue}
                id="mmama-entities-master-search"
                loading={masterEntitiesList.length === 0}
                onChange={(id) => onMasterEntityChange({ target: { value: id } })}
                input={{
                  id: 'mmama-entities-master-search-input',
                  name: 'mmama-entities-master-search-input'
                }}
              />
            </AvGroup>
          </>
        )}
      </AvForm>

      <br />
      <div className="table-responsive">
        {mmamaEntityList && mmamaEntityList.length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th>ID</th>
              <th>English Description</th>
              <th>Local Language Description</th>
              <th>Display Order</th>
              <th>Required</th>
              <th>Active Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {mmamaEntityList.map((mmamaEntity, i) => (
              <tr key={`entity-${i}`}>
                <td>{mmamaEntity.id}</td>
                <td>{mmamaEntity.enDescription}</td>
                <td>{mmamaEntity.stDescription}</td>
                <td>{mmamaEntity.displayOrder}</td>
                <td>{mmamaEntity.required ? 'Yes' : 'No'}</td>
                <td>{mmamaEntity.isActive ? 'Active' : 'Inactive'}</td>
                <td className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button tag={Link} to={`${match.url}/${mmamaEntity.id}/edit?masterEntityId=${activeMasterEntity.id}&countryId=${activeCountry.id}`} color="primary" size="sm">
                      <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">View/Edit</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Entites Found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ mmamaEntity, authentication, region }: IRootState) => ({
  mmamaEntityList: mmamaEntity.entities,
  masterEntities: mmamaEntity.masterEntities,
  loading: mmamaEntity.loading,
  countries: region.countries,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN']),
  hasUpdateAccess: hasAnyPermission(authentication.permissions, ['ADMIN', 'ENTITIES_MODIFY']),
});

const mapDispatchToProps = {
  getEntities,
  getCountries,
  getMasterEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MmamaEntity);
